'use client';
import Image from 'next/image';
import Icon from '../Icon';

interface Props { navigate: (s: string) => void; }

const MONO = "'JetBrains Mono',monospace";

function PhoneFrame({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
      <span style={{ fontFamily: MONO, fontSize: 13, color: '#737685' }}>{label}</span>
      <div style={{ width: 320, height: 660, flexShrink: 0, background: '#051a3e', borderRadius: 44, padding: 12, boxShadow: '0 22px 54px rgba(5,26,62,.2)' }}>
        <div style={{ width: '100%', height: '100%', background: '#faf9ff', borderRadius: 33, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          {children}
        </div>
      </div>
    </div>
  );
}

function StatusBar() {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 22px 6px', fontFamily: MONO, fontSize: 12, fontWeight: 600 }}>
      <span>9:41</span>
      <span style={{ display: 'flex', gap: 5 }}>
        <Icon name="signal_cellular_alt" size={15} />
        <Icon name="wifi" size={15} />
        <Icon name="battery_full" size={15} />
      </span>
    </div>
  );
}

export default function MobileScreen({ navigate }: Props) {
  return (
    <main className="vpad" style={{ maxWidth: 1280, margin: '0 auto', padding: '36px 24px 80px', animation: 'vfade .4s ease' }}>
      <div style={{ textAlign: 'center', marginBottom: 32 }}>
        <h1 className="vh2" style={{ fontSize: 32, fontWeight: 700, letterSpacing: '-.015em', margin: '0 0 6px' }}>모바일 화면 미리보기</h1>
        <p style={{ fontSize: 16, color: '#434654', margin: 0 }}>반응형 레이아웃 — 칸반은 세로 스크롤, 대시보드는 하단 탭 바로 전환됩니다.</p>
      </div>

      <div style={{ display: 'flex', gap: 40, flexWrap: 'wrap', justifyContent: 'center', alignItems: 'flex-start' }}>
        {/* 홈 */}
        <PhoneFrame label="홈 / 맞춤 공고">
          <StatusBar />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 18px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <Image src="/vster-logo.png" alt="부스터" width={968} height={492} style={{ height: 22, width: 'auto' }} />
              <span style={{ fontSize: 15, fontWeight: 700, color: '#051a3e', paddingLeft: 6, borderLeft: '1px solid #d8e2ff' }}>부스터</span>
            </div>
            <Icon name="menu" size={24} color="#434654" />
          </div>
          <div style={{ flex: 1, overflow: 'hidden', padding: '8px 16px', display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <h2 style={{ fontSize: 22, fontWeight: 700, lineHeight: 1.25, margin: '0 0 10px' }}>흩어진 정부지원사업,<br /><span style={{ color: '#003d9b' }}>AI가 찾아줘요</span></h2>
              <div style={{ position: 'relative' }}>
                <Icon name="search" size={20} color="#737685" style={{ position: 'absolute', left: 13, top: '50%', transform: 'translateY(-50%)' }} />
                <div style={{ height: 46, borderRadius: 12, border: '1px solid #c3c6d6', background: '#fff', display: 'flex', alignItems: 'center', paddingLeft: 42, fontSize: 14, color: '#737685' }}>업종·키워드 검색</div>
              </div>
            </div>
            {[{ match: '98%', dday: 'D-1', ddBg: '#ba1a1a', title: '창업성장기술개발 (디딤돌 R&D)', org: '중소벤처기업부', amount: '최대 1.2억원' }, { match: '94%', dday: 'D-3', ddBg: '#f97316', title: '초기창업패키지', org: '창업진흥원 · K-Startup', amount: '최대 1억원' }].map((p, i) => (
              <div key={i} style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 13, padding: 14, display: 'flex', flexDirection: 'column', gap: 8, boxShadow: '0 2px 10px rgba(5,26,62,.04)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontFamily: MONO, fontSize: 11, color: '#005f71', background: '#50dcff', padding: '3px 9px', borderRadius: 999 }}>{p.match} 일치</span>
                  <span style={{ fontFamily: MONO, fontSize: 11, fontWeight: 600, background: p.ddBg, color: '#fff', padding: '3px 8px', borderRadius: 6 }}>{p.dday}</span>
                </div>
                <h3 style={{ fontSize: 15, fontWeight: 600, lineHeight: 1.3, margin: 0 }}>{p.title}</h3>
                <span style={{ fontFamily: MONO, fontSize: 11, color: '#737685' }}>{p.org}</span>
                <span style={{ fontSize: 15, fontWeight: 700, color: '#003d9b' }}>{p.amount}</span>
              </div>
            ))}
          </div>
        </PhoneFrame>

        {/* 대시보드 */}
        <PhoneFrame label="대시보드 + 하단 탭">
          <StatusBar />
          <div style={{ flex: 1, overflow: 'hidden', padding: '14px 16px 70px', display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <div style={{ fontSize: 13, color: '#737685' }}>반갑습니다</div>
              <h2 style={{ fontSize: 21, fontWeight: 700, margin: '2px 0 0' }}>정원테크님 👋</h2>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <div style={{ flex: 1, background: '#fff', border: '1px solid #e4e8f6', borderRadius: 13, padding: 13 }}>
                <Icon name="bookmark" size={20} color="#003d9b" fill={1} />
                <div style={{ fontSize: 12, color: '#434654', marginTop: 6 }}>관심</div>
                <div style={{ fontSize: 26, fontWeight: 700 }}>12</div>
              </div>
              <div style={{ flex: 1, background: '#fff', border: '1.5px solid #ffdad6', borderRadius: 13, padding: 13 }}>
                <Icon name="event" size={20} color="#93000a" fill={1} />
                <div style={{ fontSize: 12, color: '#434654', marginTop: 6 }}>마감 임박</div>
                <div style={{ fontSize: 26, fontWeight: 700, color: '#ba1a1a' }}>2</div>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
              <Icon name="auto_awesome" size={18} color="#00687b" fill={1} />
              <span style={{ fontSize: 15, fontWeight: 700 }}>맞춤 추천</span>
            </div>
            <div style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 13, padding: 14, display: 'flex', flexDirection: 'column', gap: 8, boxShadow: '0 2px 10px rgba(5,26,62,.04)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontFamily: MONO, fontSize: 11, color: '#005f71', background: '#50dcff', padding: '3px 9px', borderRadius: 999 }}>88% 일치</span>
                <span style={{ fontFamily: MONO, fontSize: 11, fontWeight: 600, background: '#fde68a', color: '#854d0e', padding: '3px 8px', borderRadius: 6 }}>D-7</span>
              </div>
              <h3 style={{ fontSize: 15, fontWeight: 600, margin: 0 }}>2026 수출바우처 지원사업</h3>
              <span style={{ fontFamily: MONO, fontSize: 11, color: '#737685' }}>KOTRA · 기업마당</span>
            </div>
          </div>
          {/* 하단 탭 */}
          <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 62, background: '#fff', borderTop: '1px solid #e4e8f6', display: 'flex', alignItems: 'center', justifyContent: 'space-around', paddingBottom: 6 }}>
            {[{ icon: 'dashboard', label: '대시보드', active: true }, { icon: 'view_kanban', label: '칸반' }, { icon: 'calendar_month', label: '플래너' }, { icon: 'list_alt', label: '공고' }].map(t => (
              <span key={t.label} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, color: t.active ? '#003d9b' : '#737685' }}>
                <Icon name={t.icon} size={23} fill={t.active ? 1 : 0} />
                <span style={{ fontFamily: MONO, fontSize: 9 }}>{t.label}</span>
              </span>
            ))}
          </div>
        </PhoneFrame>

        {/* 칸반 */}
        <PhoneFrame label="칸반 (세로 스크롤)">
          <StatusBar />
          <div style={{ padding: '10px 16px 6px' }}>
            <h2 style={{ fontSize: 19, fontWeight: 700, margin: 0 }}>트래킹 보드</h2>
          </div>
          <div style={{ flex: 1, overflow: 'hidden', padding: '6px 16px', display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#003d9b', display: 'inline-block' }} />
                <span style={{ fontSize: 14, fontWeight: 700 }}>준비 중</span>
                <span style={{ fontFamily: MONO, fontSize: 11, color: '#737685', background: '#e9edff', padding: '1px 7px', borderRadius: 999 }}>2</span>
              </div>
              {[{ tag: 'R&D', dday: 'D-1', ddBg: '#ba1a1a', title: '창업성장기술개발 R&D', memo: '예산 산정표 최종 검토' }, { tag: '사업화', dday: 'D-3', ddBg: '#f97316', title: '초기창업패키지', memo: '' }].map((c, i) => (
                <div key={i} style={{ background: '#fff', border: `1.5px solid ${c.ddBg}`, borderRadius: 12, padding: 12, display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ fontFamily: MONO, fontSize: 10, background: '#f1f3ff', color: '#434654', padding: '2px 7px', borderRadius: 5 }}>{c.tag}</span>
                    <span style={{ fontFamily: MONO, fontSize: 10, fontWeight: 600, background: c.ddBg, color: '#fff', padding: '2px 7px', borderRadius: 5 }}>{c.dday}</span>
                  </div>
                  <h4 style={{ fontSize: 14, fontWeight: 600, margin: 0 }}>{c.title}</h4>
                  {c.memo && <div style={{ background: '#f1f3ff', borderRadius: 7, padding: '6px 9px', fontSize: 11, color: '#434654' }}>{c.memo}</div>}
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#1f8a5b', display: 'inline-block' }} />
                <span style={{ fontSize: 14, fontWeight: 700 }}>선정 / 탈락</span>
              </div>
              <div style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 12, padding: 12, display: 'flex', flexDirection: 'column', gap: 6 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontFamily: MONO, fontSize: 10, background: '#f1f3ff', color: '#434654', padding: '2px 7px', borderRadius: 5 }}>사업화</span>
                  <span style={{ fontFamily: MONO, fontSize: 10, fontWeight: 600, background: '#d6f0e2', color: '#10663f', padding: '2px 7px', borderRadius: 5 }}>선정</span>
                </div>
                <h4 style={{ fontSize: 14, fontWeight: 600, margin: 0 }}>청년창업사관학교 14기</h4>
              </div>
            </div>
          </div>
        </PhoneFrame>
      </div>
    </main>
  );
}
